export default "__VITE_ASSET__5dce735d__"